module.exports = __webpack_public_path__ + "img/logo_pracevostrave.9428129.svg";